// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { syncAccessTokenCookie } from '@/lib/crossDomainAuth';

function stripInjectedSessionParamsBeforeClientInit(): void {
  if (typeof window === 'undefined') return

  // Auth callback routes expect tokens in the URL — skip stripping so the
  // cross-domain SSO flow (and Supabase PKCE) can read them normally.
  const authCallbackPaths = ['/auth/callback', '/accept-invite']
  if (authCallbackPaths.some(p => window.location.pathname === p)) return

  const dangerousParams = [
    'access_token',
    'refresh_token',
    'provider_token',
    'provider_refresh_token',
    'session_id',
  ]
  const url = new URL(window.location.href)
  let changed = false

  for (const key of dangerousParams) {
    if (url.searchParams.has(key)) {
      url.searchParams.delete(key)
      changed = true
    }
  }

  if (url.hash) {
    const hashParams = new URLSearchParams(url.hash.replace(/^#/, ''))
    for (const key of dangerousParams) {
      if (hashParams.has(key)) {
        hashParams.delete(key)
        changed = true
      }
    }
    const nextHash = hashParams.toString()
    url.hash = nextHash ? `#${nextHash}` : ''
  }

  if (changed) {
    window.history.replaceState(window.history.state, document.title, url.toString())
  }
}

stripInjectedSessionParamsBeforeClientInit()

// Use environment variables or fallback to production
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://oitlhxqyfcxwterungzs.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9pdGxoeHF5ZmN4d3RlcnVuZ3pzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwODE5NTMsImV4cCI6MjA3MDY1Nzk1M30.kgj_4cdqVfXHQ3vSHQNa-HMQeWBQLW7yCMBQtk0dlSw";

const crossDomainStorage = {
  getItem: (key: string) => localStorage.getItem(key),
  setItem: (key: string, value: string) => {
    localStorage.setItem(key, value);
    try {
      const parsed = JSON.parse(value) as { access_token?: string };
      syncAccessTokenCookie(parsed.access_token ?? null);
    } catch {
      syncAccessTokenCookie(null);
    }
  },
  removeItem: (key: string) => {
    localStorage.removeItem(key);
    syncAccessTokenCookie(null);
  },
};

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";
// For chat schema tables (messages, conversations):
// import { chatSupabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: crossDomainStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// Client scoped to the chat schema (messages, conversations).
// Replaces legacy public views: chat_messages_instagram → messages, chats_Instagram → conversations
export const chatSupabase = supabase.schema('chat');
